import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../styles/ShopCard.module.css';

const publicUrl = process.env.PUBLIC_URL || '';

const ShopCard = ({ product, onAdd }) => (
  <article className={styles.card}>
    <Link className={styles.imageLink} to={`${publicUrl}/Shop/${product.id}`}>
      <div className={styles.imageWrap}>
        <img
          className={styles.image}
          src={product.image}
          alt={product.name}
          loading="lazy"
          decoding="async"
        />
      </div>
    </Link>
    <div className={styles.copy}>
      <p className={styles.category}>{product.category}</p>
      <h3><Link className={styles.titleLink} to={`${publicUrl}/Shop/${product.id}`}>{product.name}</Link></h3>
      <p className={styles.description}>{product.description}</p>
      <div className={styles.footer}>
        <strong>{product.price.toFixed(2).replace('.', ',')} €</strong>
        <div className={styles.actions}>
          <Link className={styles.detailsLink} to={`${publicUrl}/Shop/${product.id}`}>
            Details
          </Link>
          <button type="button" onClick={() => onAdd(product)}>Add to cart</button>
        </div>
      </div>
    </div>
  </article>
);

export default ShopCard;
